import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Grid, Row, Col} from 'react-bootstrap'
import UserEditForm from './user-edit-form'
import BackLink from '../../../common/back-link/index'
import PageTitle from '../../../common/page-title/index'
import {getUserEdit} from '../../../../actions/users'

import './styles.css'

class EditUser extends Component {

  componentWillMount() {
    const {dispatch} = this.props;
    this.id = +this.props.match.params.id;

    if(this.id){
      dispatch(getUserEdit(this.id))
    } else {
      dispatch(actions.reset('deep.admin_user.edit'));
    }
  }

  componentWillUnmount(){
    const {dispatch} = this.props;

    dispatch(actions.reset('deep.admin_user.edit'));
    dispatch({type: 'CLEAR_EDIT_USER'});
  }

  render() {
    const {user} = this.props;

    return (
      <Grid bsClass="container" fluid className="users">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/users"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>Add/Edit user</PageTitle>
          </Col>
        </Row>
        {
          this.props.user && <UserEditForm user={user} id={this.id} edit={!!this.id}/>
        }
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
    user: state.users.user,
    fetched: state.users.fetched,
    fetching: state.users.fetching,
  };
};

export default connect(mapStateToProps)(EditUser);



// WEBPACK FOOTER //
// ./src/components/admin/users/edit/edit.jsx